/**
 * CollectionIcon - Icon representing photo collections
 * Line-based grid of photos icon
 */

import type { IconProps } from './IconTypes';

export function CollectionIcon({
  size = 20,
  className = '',
  'aria-label': ariaLabel = 'Collection',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-label={ariaLabel}
      role="img"
    >
      {/* 2x2 grid of photos */}
      <rect x="3" y="3" width="7" height="7" rx="1" />
      <rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" />
      <rect x="14" y="14" width="7" height="7" rx="1" />
    </svg>
  );
}
